// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "Footer-module--wrapper--3Dabq";
export var cellWrapper = "Footer-module--cellWrapper--1e3cH";
export var title = "Footer-module--title--Kfno6";
export var sectors = "Footer-module--sectors--t17R1";
export var address = "Footer-module--address--OlsIj";
export var topRowCell = "Footer-module--topRowCell--0n0xm";
export var bottomRowCell = "Footer-module--bottomRowCell--mkEtd";
export var leftBlock = "Footer-module--leftBlock--b0pHO";
export var centeredBlock = "Footer-module--centeredBlock--ogyjW";
export var rightBlock = "Footer-module--rightBlock--VXn4g";
export var aboutWebfolio = "Footer-module--aboutWebfolio--WXn1-";
export var link = "Footer-module--link--JXyLd";
export var volumeIcon = "Footer-module--volumeIcon--53Im4";
export var preBlock = "Footer-module--preBlock--L+3UM";